<template>
  <div class="action ui-refresh-extend">
    <DatePickerPopup
      :key="defaultValue"
      :index1Value="defaultValue"
      :refreshInterval="refreshInterval"
      :isDashboard="isDashboard"
      :refreshTime="true"
      :isPerformance="isPerformance"
      :isMonitoringPerformance="isMonitoringPerformance"
      @save="onSave"
      @close="togglePopup"
      @open="togglePopup"
      @inited="initedDatePicker"
    >
      <div class="group-icon">
        <div class="time-text">
          <span>{{ getTime }}</span>
        </div>
        <lego-icon-button
          iconType="line"
          icon="refresh_new"
          class="ui-icon hover-icon"
          @click="refresh"
          :disabled="loading"
          v-lego-tooltip="$t('label.refresh')"
        />
        <div style="display: flex">
          <lego-icon-button
            v-show="!isRefreshPlay"
            iconType="df"
            icon="play"
            class="ui-icon icon-play"
            @click="onStart"
            v-lego-tooltip="$t('label.refreshPlay')"
          />

          <lego-icon-button
            v-show="isRefreshPlay"
            iconType="line"
            icon="pause"
            class="ui-icon i-pause hover-icon"
            @click="onPause"
            v-lego-tooltip="$t('label.refreshPause')"
          />
          <lego-progress
            :modelvalue="progressValue"
            :width="100"
            progressType="line"
            determinate
            class="progress-line-custom"
          />
        </div>
        <div class="count-down-time">{{ getCountdownTime }}</div>
      </div>
    </DatePickerPopup>
  </div>
</template>

<script>
import moment from 'moment';
import i18nMixin from '@/mixins/i18n.mixin.js';
import DatePickerPopup from '@/components/scpm/components/rangeDatePickerPopup';
import { computed } from 'vue';
import { useDateTimeFormat } from '@/composables/useDateTimeFormat';

const { formatDateTime } = useDateTimeFormat();

export default {
  components: {
    DatePickerPopup
  },
  emits: ['save', 'refresh'],
  mixins: [i18nMixin],
  props: {
    refreshPlay: { type: Boolean, default: false },
    isPerformance: { type: Boolean, default: false },
    isMonitoringPerformance: { type: Boolean, default: false },
    defaultValue: {
      type: String,
      default: '30m'
    },
    startDate: { type: String, default: '' },
    dateTime: { type: Object, default: null },
    isDashboard: { type: Boolean, default: false },
    isApp: { type: Boolean, default: false }
  },
  mounted() {
    this.showNow();
    if (this.refreshPlay) {
      this.startPlay();
    } else {
      this.refreshTime();
    }
  },
  computed: {
    progressValue() {
      const progress = (this.countInterval / (this.refreshInterval * 60)) * 100 || 0;
      return progress > 100 ? 100 : progress;
    },
    getTime() {
      const period =
        this.date.dateType === 1 ? this.date.tab1Text : this.$t('label.customCapitalize');
      if (this.startDate) {
        const eDate = formatDateTime(this.startDate);
        const sDate = formatDateTime(moment(this.startDate).subtract(30, 'minutes'));

        return `${period} (${sDate} ~ ${eDate})`;
      }

      if (_.isEmpty(this.date)) {
        const previousTime = moment().subtract(30, 'minutes');
        const formatDate = formatDateTime(previousTime);

        return `${period} (${formatDate} ~ ${this.now})`;
      } else {
        let startDate = '';
        const endDate = formatDateTime(this.date.queryEndDt);
        if (this.date.dateType === 1) {
          let previousTime = '';
          const periodTime = this.date.tab1value;

          if (periodTime === '14d' || periodTime === '7d' || periodTime === '3d') {
            previousTime = moment().subtract(parseInt(periodTime.slice(0, -1)), 'days');
          } else if (
            periodTime === '3h' ||
            periodTime === '6h' ||
            periodTime === '12h' ||
            periodTime === '24h'
          ) {
            previousTime = moment().subtract(parseInt(periodTime.slice(0, -1)), 'hours');
          } else {
            previousTime = moment().subtract(parseInt(periodTime.slice(0, -1)), 'minutes');
          }

          startDate = formatDateTime(previousTime);
        } else {
          startDate = formatDateTime(this.date.queryStartDt);
        }
        return `${period} (${startDate} ~ ${endDate})`;
      }
    },
    getCountdownTime() {
      return `${this.minutes}:${this.seconds}`;
    }
  },
  beforeUnmount() {
    if (this.isRefreshPlay) {
      this.stopPlay();
    }
  },
  data() {
    return {
      now: '',
      isRefreshPlay: this.$props.refreshPlay,
      loading: false,
      refreshInterval:
        this.dateTime && this.dateTime.refreshInterval ? this.dateTime.refreshInterval : '1',
      playTimer: {},
      date: {},
      countInterval: 0,
      countdownSeconds: 0,
      minutes: '00',
      seconds: '00',
      progressTime: {},
      intervalId: {},
      datePickerRef: null,
      refreshed: false
    };
  },
  provide() {
    return {
      startDate: computed(() => this.startDate),
      updateInquiry: this.updateInquiryTime
    };
  },
  watch: {
    refreshInterval() {
      if (this.date.dateType === 1) {
        this.isRefreshPlay = true;
        this.startPlay();
      }
    },
    refreshPlay: {
      handler(nv) {
        this.isRefreshPlay = nv;
        if (nv) return this.startPlay();
        this.refreshTime();
        this.stopPlay();
      }
    }
  },
  methods: {
    initedDatePicker(refPopup) {
      if (refPopup) {
        this.datePickerRef = refPopup;
        this.date = refPopup.getCurrentDate();
      }
    },
    // NEW
    refresh() {
      // 데이터 새로고침.
      if ((!this.isPerformance || !this.startDate) && this.refreshed) {
        this.date = this.datePickerRef.getCurrentDate();
      }
      if (!this.loading) {
        this.showNow();

        if (this.isRefreshPlay) {
          this.countInterval = 0;
          this.startPlay(false);
        }

        this.$emit('refresh', this.isApp);
      }

      this.loading = true;
      window.setTimeout(() => {
        this.loading = false;
      }, 2000);
    },
    togglePopup(isClosed) {
      this.refreshed = !isClosed;
    },
    onStart() {
      if (!this.isRefreshPlay) {
        this.isRefreshPlay = true;
        this.startPlay();
      }
    },
    onPause(onPaused = null) {
      if (this.isRefreshPlay) {
        this.isRefreshPlay = false;
        this.stopPlay();
        if (onPaused && typeof onPaused === 'function') {
          onPaused();
        }
      }
    },
    showNow() {
      this.now = formatDateTime();
    },
    updateInquiryTime() {
      this.date = this.datePickerRef.getCurrentDate();
      this.showNow();
    },
    startPlay(keepTime = true) {
      window.clearInterval(this.progressTime);
      const [minutes, seconds] = this.getCountdownTime.split(':').map(Number);
      const totalMinutes = minutes + seconds / 60;
      this.progressTime = window.setInterval(() => {
        this.countInterval = this.countInterval + 1;
      }, 1000);
      const checkKeepTime = totalMinutes > 0 && totalMinutes < this.refreshInterval && keepTime;
      if (checkKeepTime) {
        this.countdownTimer(minutes, seconds - 1);
      } else {
        this.countdownTimer(this.refreshInterval);
      }
      this.playTimer = window.setInterval(() => {
        if (parseInt(this.minutes) === 0 && parseInt(this.seconds) === 0) {
          this.refreshed = true;
          this.refresh();
        }
      }, 1000);
    },
    stopPlay() {
      window.clearInterval(this.progressTime);
      window.clearInterval(this.playTimer);
      window.clearInterval(this.intervalId);
    },
    onSave(param) {
      this.refreshInterval = param.refresh;
      this.date = param.date;
      if (this.date.dateType === 2) {
        this.isRefreshPlay = false;
        this.stopPlay();
      }
      this.$emit('save');
      this.resetReloadTime();
    },
    resetReloadTime() {
      this.refreshTime();
      if (this.isRefreshPlay) {
        this.showNow();
        this.stopPlay();
        this.startPlay();
      }
    },
    getCurrentDate() {
      return {
        refreshInterval: this.refreshInterval,
        queryEndDt: this.date.queryEndDt,
        queryStartDt: this.date.queryStartDt,
        chartTimeUnit: this.date.chartTimeUnit,
        dateType: this.date.dateType,
        tab1value: this.date.tab1value,
        isRefreshPlay: this.isRefreshPlay,
        isNow: this.date.isNow,
        tab1Text: this.date.tab1Text
      };
    },
    setDate(d) {
      if (typeof d !== 'string') {
        this.refreshInterval = d.refreshInterval.toString();
      }

      if (this.datePickerRef) {
        this.datePickerRef.setDate(d);
      }
    },
    setDefalut(isCheck = false, isReset = false) {
      if (this.datePickerRef) {
        this.datePickerRef.setDefalut(isCheck, isReset);
      }
    },
    countdownTimer(minutes, seconds = 0) {
      let remainingSeconds = parseInt(minutes) * 60 + parseInt(seconds);
      window.clearInterval(this.intervalId);
      this.intervalId = window.setInterval(() => {
        const minutes = Math.floor(remainingSeconds / 60);
        this.minutes = minutes < 10 ? '0' + minutes : minutes;
        const seconds = remainingSeconds % 60;
        this.seconds = seconds < 10 ? '0' + seconds : seconds;
        remainingSeconds--;
        if (remainingSeconds < 0) {
          window.clearInterval(this.intervalId);
        }
      }, 1000);
    },
    refreshTime() {
      this.countInterval = 0;
      this.minutes = this.refreshInterval < 10 ? `0${this.refreshInterval}` : this.refreshInterval;
      this.seconds = '00';
    },
    reloadComponent() {
      this.isRefreshPlay = true;
      this.refreshInterval = '1';
      this.datePickerRef.refreshInterval = '1';
      this.resetReloadTime();
    },
    setRefreshInterval(value) {
      this.refreshInterval = value;
    }
  }
};
</script>
<style lang="scss" scoped>
.action.ui-refresh-extend {
  .count-down-time {
    margin: 0px !important;
  }
  .lego-button--border.lego-button--default {
    background-color: unset;
  }
  .lego-button--disabled.lego-button--border {
    background-color: unset !important;
  }
  .group-icon {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-right: 8px;
    .time-text {
      margin-right: 12px;
    }
  }
  .hover-icon {
    :deep .lego-icon:hover {
      color: #22252a;
    }
  }
  :deep {
    .ui-icon {
      .opus-icon__play {
        svg:hover {
          color: #00a7ff !important;
        }
      }
    }
  }
}
:deep .lego-tooltip {
  padding: 6px 5px !important;
}

:deep {
  .ui-icon {
    width: 24px !important;
    height: 24px !important;
  }
  .ui-icon > i {
    width: 20px;
    height: 20px;
  }
  .ui-icon.i-pause > i {
    font-size: 20px !important;
  }

  .progress-line-custom > .lego-progress__line {
    height: 3px;
    border-radius: 4px;
    .lego-progress__line-progress {
      height: 3px;
    }
  }

  .progress-line-custom
    > .lego-progress__line-background-normal
    > .lego-progress__line-progress-normal {
    background-color: #2c5ad8;
  }
  .icon-play > i.opus-icon__play {
    font-size: 20px !important;
  }
  .progress-line-custom > .lego-progress__line-background-normal {
    background-color: #e3e4e5;
  }
}

.ui-refresh-extend {
  :deep(.rangedate
      .lego-dropdown__items
      .datepicker-tab-container
      .datatime-type-wrap
      .lego-date-picker) {
    width: 100% !important;
  }
}
// @style/ui/component/element/
/* 20220805 icon pause add */
</style>
